// Target:DEV

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import Moment from 'moment/moment'
import jQuery from 'jquery'
import UIkit from 'uikit/dist/js/uikit.js'
import UIkitCSS from 'uikit/dist/css/uikit.css'
import UIkitIcon from 'uikit/dist/js/uikit-icons'
import IdleTimeout from 'idle-timeout'
import { DatePicker, TimePicker, TimeSelect } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'

require('@fortawesome/fontawesome')
require('@fortawesome/fontawesome-free-solid')
require('@fortawesome/fontawesome-free-regular')
require('@fortawesome/fontawesome-free-brands')

// 定数のグローバル追加
// global.API_BASE = 'http://cnx_test.com/api_v2/'
// global.API_BASE = 'http://reserve.d-opesy.biz/api_v2/'
// global.API_BASE = 'http://localhost:8000/'
// global.API_BASE = 'http://153.127.250.234/api_v2/'
// global.API_BASE = 'http://180.12.182.100/api_v2/'
global.APP_VERSION = '1.5.0'
global.APP_NAME = 'rfms'

global.S3_URL = 'https://d3enmzorqh80ic.cloudfront.net/'

global.API_BASE = location.origin + '/api_v2/'

// ライブラリのグローバル追加
global.router = router
global.moment = Moment
global.Axios = Axios
global.$ = jQuery
global.jQuery = jQuery
global.UIkit = UIkit
global.IdleTimeout = IdleTimeout

// Axios
Axios.defaults.baseURL = API_BASE
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
Axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
Axios.defaults.withCredentials = true

// UIkit
UIkit.use(UIkitIcon)

// Moment
moment.locale('ja', {weekdays: ['日', '月', '火', '水', '木', '金', '土']})

// Vue
Vue.config.productionTip = false

// ElementUI
locale.use(lang)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(TimeSelect)

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {App},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js